import { Alerte } from '@/model/alerte';
import Axios from 'axios';
import { ApiUtils } from './api-utils';
import { CodeDomaine } from '@/model/enum-types/code-domaine';

export class AlerteApi {
  static getAllAlertes (domaine: CodeDomaine, userName: string): Promise<Alerte[]> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/users/${userName}/alertes`), [Alerte]);
  }

  static suspendreAlerte (domaine: CodeDomaine, userName: string, alerte: Alerte): Promise<void> {
    return Axios.post(`/web/v1/alertes/${alerte.id}/suspendre`).then(() => { });
  }

  static supprimerAlerte (domaine: CodeDomaine, userName: string, alerte: Alerte): Promise<void> {
    return Axios.delete(`/web/v1/alertes/${alerte.id}`).then(() => { });
  }

  static ajouterAlerte (domaine: CodeDomaine, userName: string, alerte: Alerte): Promise<Alerte> {
    return ApiUtils.responseParser(Axios.post(`/web/v1/users/${userName}/alertes`, alerte), Alerte);
  }

  static modifierAlerte (domaine: CodeDomaine, userName: string, alerte: Alerte): Promise<void> {
    return Axios.put(`/web/v1/alertes/${alerte.id}`, alerte).then(() => { });
  }
}
